import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

/**
 * Wraps a route to require authentication.
 * If `requiredRole` is provided, also enforces that role.
 */
const PrivateRoute = ({ children, requiredRole }) => {
  const [user, , , authReady] = useAuth();

  if (!authReady) return null;
  if (!user) return <Navigate to="/login" />;
  if (requiredRole && user.role !== requiredRole) {
    // Redirect to the right home for their actual role
    return <Navigate to={user.role === 'admin' ? '/admin' : '/submit'} />;
  }
  return children;
};

export default PrivateRoute;
